import { createElementBlock as e, openBlock as o, createElementVNode as r } from "vue";
import c from "./index289.js";
const l = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(a, t, p, i, m, f) {
  return o(), e("svg", n, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M12 2.25c5.278 0 9.593 4.2 9.746 9.474l.004.276c0 5.278-4.2 9.593-9.474 9.746L12 21.75c-5.278 0-9.593-4.2-9.746-9.474L2.25 12c0-5.278 4.2-9.593 9.474-9.746Zm0 1.5-.244.004c-4.453.128-8.006 3.78-8.006 8.235l.004.255c.128 4.453 3.78 8.006 8.235 8.006l.255-.004c4.453-.128 8.006-3.78 8.006-8.235l-.004-.255A8.25 8.25 0 0 0 12 3.75Zm-.001 11.5.117.007a1 1 0 1 1-.226-.001l.109-.006ZM12 6.75a.75.75 0 0 1 .743.648l.007.102v5a.75.75 0 0 1-1.493.102l-.007-.102v-5a.75.75 0 0 1 .75-.75Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ c(l, [["render", s]]);
export {
  u as default
};
